'use client';

import { useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
import SectionTitle from '../ui/SectionTitle';
import AnimatedSection from '../ui/AnimatedSection';
import { getSoinBySlug } from '@/app/lib/soins';

const CAL_NAMESPACE = 'booking';

interface BookingCalendarProps {
  soinSlug?: string;
}

function BookingCalendar({ soinSlug }: BookingCalendarProps) {
  const calUrl = process.env.NEXT_PUBLIC_CAL_URL;
  const calUsername = process.env.NEXT_PUBLIC_CAL_LINK;
  const selectedSoin = getSoinBySlug(soinSlug ?? '');
  const calLink = selectedSoin ? `${calUsername}/${selectedSoin.slug}` : calUsername;

  useEffect(() => {
    if (!calUrl || !calLink) return;

    (async function () {
      const cal = await getCalApi({
        namespace: CAL_NAMESPACE,
        embedJsUrl: `${calUrl}/embed/embed.js`,
      });
      cal('ui', {
        theme: 'light',
        cssVarsPerTheme: {
          light: { 'cal-brand': '#2f4a3e' },
          dark: { 'cal-brand': '#2f4a3e' },
        },
        hideEventTypeDetails: false,
        layout: 'month_view',
      });
    })();
  }, [calUrl, calLink]);

  if (!calUrl || !calLink) return null;

  return (
    /* Hauteur limitée : la liste des services défile dans le cadre */
    <div className="rounded-2xl overflow-y-auto max-h-[min(720px,75svh)] shadow-sm border border-cream-200 bg-white">
      <Cal
        namespace={CAL_NAMESPACE}
        calLink={calLink}
        calOrigin={calUrl}
        embedJsUrl={`${calUrl}/embed/embed.js`}
        style={{ width: '100%', minHeight: '480px' }}
        config={{
          layout: 'month_view',
        }}
      />
    </div>
  );
}

interface BookingProps {
  soinSlug?: string;
  title?: string;
  subtitle?: string;
}

export default function Booking({
  soinSlug,
  title = 'Prenez soin de vous',
  subtitle = 'Réservez votre séance en quelques clics, directement depuis mon agenda en ligne.',
}: BookingProps) {
  return (
    <section id="booking" className="py-24 bg-cream-100">
      <div className="max-w-4xl mx-auto px-6">
        <AnimatedSection>
          <SectionTitle eyebrow="Réservation" title={title} subtitle={subtitle} />
        </AnimatedSection>

        <AnimatedSection delay={0.15} className="mt-12">
          <BookingCalendar soinSlug={soinSlug} />
        </AnimatedSection>
      </div>
    </section>
  );
}


